




import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { Component } from '@niknevis/vue-modules'
import { BankAccountType } from '@/modules/bank-account/models/bank-account-resource.model'

@Component
export default class BankAccountTypeView extends Vue {
  @Prop({ required: true }) type!: BankAccountType
  @Prop({ required: true }) types!: { [key in BankAccountType]: string }
  @Prop({ default: false }) dark: boolean

  get typeColor() {
    switch (this.type) {
      case BankAccountType.LEGAL_PERSON:
        return 'text-blue'
      case BankAccountType.NATURAL_PERSON:
        return 'text-green'
      default:
        return ''
    }
  }
}
